<template>
  <div>
    <div v-show="PageShow" class="pageLoading">
      <div class="load">
        <van-loading type="circular" vertical>加载中...</van-loading>
      </div>
    </div>
    <!-- <van-sticky v-show="!PageShow" @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <van-nav-bar title="订单发货" left-text="返回" left-arrow @click-left="onClickLeft"/>
    </van-sticky> -->
    <van-cell class="hearderVanCell" title="订单号:">
      <template slot="default">
        <div v-show="deliveryForm.status">
          <van-tag v-if="deliveryForm.status === '未支付'" plain type="primary">未付款</van-tag>
          <van-tag v-else-if="deliveryForm.status === '未发货'" plain type="danger">未发货</van-tag>
          <van-tag v-else plain type="success">已发货</van-tag>
        </div>
      </template>
      <template slot="label">
        {{ deliveryForm.purNo }}
      </template>
    </van-cell>
    <van-form ref="vanForm" colon class="content">
      <van-field
        readonly
        clickable
        name="picker"
        class="taocan"
        :value="tcForm.value"
        label="套餐名称"
        placeholder="点击选择套餐"
        @click="showPicker = true"
        input-align="right"
      />
      <van-field @blur="getIccIDNum" type="number" v-model="tcForm.iccidBegin" input-align="right" class="shuliang" name="firstICCID" placeholder="请输入起始ICCID" label="ICCID起始"/>
      <van-field @blur="getIccIDNum" type="number" v-model="tcForm.iccidEnd" input-align="right" class="shuliang" name="lastICCID" placeholder="请输入结束ICCID" label="ICCID结束"/>
      <van-field v-model="tcForm.number" readonly input-align="right" class="shuliang" name="number" placeholder="" label="数量"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="button" @click="addTc">确认</van-button>
      </div>
      <van-divider content-position="left">已选择套餐</van-divider>
      <DeliverGoodsVanTabContent @delOrder = delOrder class="pag" :list="tableData"></DeliverGoodsVanTabContent>
      <van-field class="shr" input-align="right" placeholder="请输入物流单号" v-model="deliveryForm.deliveryLogistics" label="物流单号" />
      <van-field class="shr" readonly input-align="right" v-model="deliveryForm.deliveryName" label="收货人名称" />
      <van-field class="shr" readonly input-align="right" v-model="deliveryForm.deliveryMobile" label="收货人电话" />
      <van-field class="shr" readonly input-align="right" v-model="deliveryForm.address" label="收货人地址" />
      <van-field class="shr" readonly input-align="right" v-model="deliveryForm.expressMode" label="快递方式" />
      <div class="footer"></div>
      <van-submit-bar v-show="!PageShow" :loading=submitLoading button-text="发货" @submit="commodityDelivery"/>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="list" @confirm="onConfirm" @cancel="showPicker = false"/>
    </van-popup>
  </div>
</template>

<script>
import DeliverGoodsVanTabContent from '../../../../components/DeliverGoodsVanTabContent'
import { userOrder, purOnlinePK, ICCIDNum, DeliveryVerif, DeliveryConfirm } from '@/api/orther.js'

export default {
  components: { DeliverGoodsVanTabContent },
  props: {},
  data () {
    return {
      // 进入当前页面加载情况
      PageShow: true,
      // 订单id
      orderId: '',
      // 是否固定头部
      stickyChangeFlag: false,
      pkquantity: '',
      // 一个套餐的 数据 form
      tcForm: {
        number: '',
        iccidBegin: '',
        iccidEnd: ''
      },
      num: [],
      // 收货人基本信息以及物流单号
      deliveryForm: {
        deliveryName: '收货人名称',
        deliveryMobile: '收货人电话',
        address: '收货人地址',
        expressMode: '快递方式'
      },
      // 添加套餐数据
      tableData: [],
      // 选择套餐名弹框
      showPicker: false,
      // 套餐名组
      list: [],
      // 是否在获取数量
      getAddTc: false,
      // 数量判断
      getSL: false,
      // 发货按钮加载
      submitLoading: false,
      // 上传发送数据的最终形态
      CommodityForm: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    // onClickLeft () { this.$router.go(-1) },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    // 订单发货校验
    async DeliveryVerification () {
      this.PageShow = true
      const { data: res } = await DeliveryVerif({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        orderId: this.orderId
      })
      if (res.code === 0 && res.msg === '操作成功') {
        this.PageShow = false
        return this.getOrderContent()
      }
      if (res.code === 1 && res.msg.indexOf('订单未完成') !== -1) {
        this.$toast.fail('订单未完成支付')
        return this.$router.push('/Purchase')
      }
      if (res.code === 1 && res.msg.indexOf('库存不足') !== -1) {
        this.$toast.fail(res.msg.split('<')[0])
        return this.$router.push('/Purchase')
      }
      if (res.code === 1 && res.msg.indexOf('订单已发货') !== -1) {
        this.$toast.fail(res.msg.split('<')[0])
        return this.$router.push('/Purchase')
      }
    },
    // 获取订单基本信息
    async getOrderContent () {
      const { data: res } = await userOrder({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], orderId: this.orderId })
      this.deliveryForm = res
      this.purOnlinePK(res)
      this.pkquantity = res.pkList.records
    },
    // 获取套餐信息
    async purOnlinePK (e) {
      this.list = []
      const { data: res } = await purOnlinePK({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      res.forEach(item => {
        e.pkList.records.forEach(items => {
          if (item.pkName === items.pkName) {
            this.list.push({
              text: item.pkName,
              value: item.packageId
            })
          }
        })
      })
    },
    // 套餐选择确定按钮
    onConfirm (value) {
      const numList = []
      if (this.num.length > 0) {
        this.num.forEach(item => {
          if (item.id === value.value) return
          numList.push({
            id: value.value,
            nums: 0
          })
        })
      } else {
        numList.push({
          id: value.value,
          nums: 0
        })
      }
      this.num = numList
      this.tcForm.value = value.text
      this.tcForm.packageId = value.value
      this.tcForm.iccidBegin = ''
      this.tcForm.iccidEnd = ''
      this.showPicker = false
    },
    // 获取卡数量
    async getIccIDNum () {
      this.getAddTc = true
      if (!this.tcForm.iccidBegin || !this.tcForm.iccidEnd) return
      const { data: res } = await ICCIDNum({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        packageId: this.tcForm.packageId,
        orderId: this.orderId,
        iccidBegins: this.tcForm.iccidBegin,
        iccidEnds: this.tcForm.iccidEnd
      })
      if (res.code === 0) {
        this.getSL = false
        this.getAddTc = false
        this.tcForm.number = res.extend.quantity
        let num = ''
        let lastNum = {}
        this.pkquantity.forEach(item => {
          if (item.package_id === this.tcForm.packageId) {
            num = item.quantity
          }
        })
        this.num.forEach(item => {
          if (item.id === this.tcForm.packageId) {
            lastNum = item
          }
        })
        if (this.tcForm.number > num) {
          this.getSL = true
          this.getAddTc = false
          return this.$toast('符合出库的数量：' + this.tcForm.number + ',套餐累加数量超过应发数量')
        }
        if (this.tcForm.number <= num) {
          this.getSL = false
          this.getAddTc = false
          lastNum.nums += this.tcForm.number
          this.num.forEach(items => {
            if (items.id === lastNum.id) {
              items.nums = lastNum.nums
            }
          })
        }
      }
      // if (res.code === 1) {
      //   this.$toast.fail(res.msg.split('<')[0])
      //   this.getAddTc = false
      // }
    },
    // 添加
    addTc () {
      if (!this.tcForm.value) return this.$toast.fail('请先选择套餐')
      if (!this.tcForm.iccidBegin) return this.$toast.fail('请先输入起始ICCID')
      if (!this.tcForm.iccidEnd) return this.$toast.fail('请先输入结束ICCID')
      if (!this.tcForm.number) return this.$toast('正在计算卡数量请稍后...')
      if (this.getAddTc) return this.$toast('正在计算卡数量请稍后...')
      if (this.getSL) return this.$toast('套餐累加数量超过应发数量，请重新填写')
      this.tableData.push({
        pkName: this.tcForm.value,
        iccidBegin: this.tcForm.iccidBegin,
        iccidEnd: this.tcForm.iccidEnd,
        num: this.tcForm.number,
        packageId: this.tcForm.packageId
      })
      this.tcForm.iccidBegin = ''
      this.tcForm.iccidEnd = ''
      this.tcForm.number = ''
    },
    // 删除
    delOrder (e) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否删除'
      }).then(() => {
        this.tableData.splice(e, 1)
      }).catch(() => {})
    },
    getCommodityForm () {
      let list = ''
      let lists = ''
      let listss = ''
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          list = item.packageId
          lists = item.iccidEnd
          listss = item.iccidBegin
        } else {
          list += ',' + item.packageId
          lists += ',' + item.iccidEnd
          listss += ',' + item.iccidBegin
        }
      })
      this.CommodityForm.packageIds = list
      this.CommodityForm.iccidEnds = lists
      this.CommodityForm.iccidBegins = listss
      this.CommodityForm.token = this.$store.state.token
      this.CommodityForm.userId = this.$store.state.userID
      this.CommodityForm.orderId = this.orderId
      this.CommodityForm.expressNo = this.deliveryForm.deliveryLogistics
    },
    async commodityDelivery () {
      if (this.tableData.length < 1) return this.$toast('请填写发货套餐信息')
      if (!this.deliveryForm.deliveryLogistics) return this.$toast('请输入物流单号')
      this.getCommodityForm()
      const { data: res } = await DeliveryConfirm(this.CommodityForm)
      if (res.code === 0) {
        this.$toast.success('发货成功！')
        return this.$router.push('/Purchase')
      }
      if (res.code === 1) {
        this.$toast.fail(res.msg.split('<')[0])
      }
    }
  },
  created () {
    this.orderId = this.$route.params.orderId
    this.DeliveryVerification()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .pageLoading {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgb(255, 255, 255);
    z-index: 1;
    .load {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%)
    }
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .hearderVanCell {
    /deep/.van-cell__title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex: 4;
      .van-cell__label {
        margin-top: 0;
        margin-left: 10px;
        font-size: 30px
      }
      .van-cell__value {
        flex: 1;
      }
    }
  }
  .content {
    position: relative;
    height: 100%;
    .taocan {
      /deep/.van-cell__value {
        flex: 4!important;
      }
    }
    .shuliang {
      /deep/.van-button {
        margin: 0!important;
        margin-left: 15px!important;
      }
    }
    .pag {
      margin-top: 20px;
    }
    .shr {
      /deep/.van-cell__title {
        flex: 1;
      }
      .van-cell__value {
        flex: 2;
      }
    }
    .footer {
      position: relative;
      height: 100px;
    }
    /deep/.van-submit-bar {
      position: absolute;
    }
    div:nth-child(8) {
      border-top: 1px solid #f5f6f7;
    }
  }
</style>
